import { Empty, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './CompactCardList.css';

// Sağdaki detay çekmecesinde kullanılan compact kart listesi.
//
// Neden tablo değil: çekmece dar ve dikey; tablo orada yatay scroll'a düşüyor,
// alttaki scrollbar'a basınca da click-away çekmeceyi kapatıyordu. Kartın sabit
// iki satırı hem masaüstünde hem mobilde aynı görünür — tek tasarım.
//
// Kart düzeni (card(record) ile verilir):
//     title                    extra
//     subLeft                  subRight
//
// Liste SAYFALANMAZ: çağıran tek seferde (100 kayıt) çeker, liste dikeyde kaydırılır.
// Yükseklik minVisibleCards kadar kart görünecek şekilde sınırlanır.
export default function CompactCardList({
    items = [],
    loading = false,
    rowKey = 'id',
    card,
    onCardClick,
    minVisibleCards = 5,
    cardHeight = 52,
    emptyText,
}) {
    const { t } = useTranslation();

    // maxHeight = en az bu kadar kart + aralarındaki boşluk. Yarım kart payı bırakılır
    // ki listenin devamı olduğu (scroll edilebildiği) görünsün.
    // minVisibleCards=0 → sınır yok: liste doğal boyunda büyür, kaydırmayı dışardaki
    // kapsayıcı yapar (örn. modal içi kullanım).
    const maxHeight = minVisibleCards > 0 ? Math.round((minVisibleCards + 0.5) * cardHeight) : undefined;

    if (loading && !items.length) {
        return (
            <div style={{ textAlign: 'center', padding: 16 }}>
                <Spin indicator={<LoadingOutlined spin />} size={'small'} />
            </div>
        );
    }

    if (!items.length) {
        return (
            <Empty
                className={'compact-card-list-empty'}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={emptyText || t('No Data')}
            />
        );
    }

    return (
        <div className={'compact-card-list'} style={{ maxHeight, opacity: loading ? 0.6 : 1 }}>
            {items.map((record, index) => {
                const { title, extra, subLeft, subRight, tooltip, color } = card(record, index) || {};
                const clickable = typeof onCardClick === 'function';

                return (
                    <div
                        key={record?.[rowKey] ?? index}
                        className={`compact-card${clickable ? ' compact-card-clickable' : ''}`}
                        style={color ? { borderLeftColor: color } : undefined}
                        // Karta sığmayan açıklama burada görünür — kart iki satırda kalır.
                        title={tooltip || undefined}
                        onClick={clickable ? () => onCardClick(record) : undefined}
                    >
                        <div className={'compact-card-line'}>
                            <div className={'compact-card-title'}>{title}</div>
                            {extra && (
                                <div
                                    className={'compact-card-extra'}
                                    // Düğmeler kartın kendi tıklamasını tetiklemesin.
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {extra}
                                </div>
                            )}
                        </div>
                        <div className={'compact-card-line compact-card-sub'}>
                            <span>{subLeft}</span>
                            <span className={'compact-card-sub-right'}>{subRight}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
